"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSessionOutput = instanceOfSessionOutput;
exports.SessionOutputFromJSON = SessionOutputFromJSON;
exports.SessionOutputFromJSONTyped = SessionOutputFromJSONTyped;
exports.SessionOutputToJSON = SessionOutputToJSON;
var Metadata_1 = require("./Metadata");
var Session_1 = require("./Session");
/**
 * Check if a given object implements the SessionOutput interface.
 */
function instanceOfSessionOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function SessionOutputFromJSON(json) {
    return SessionOutputFromJSONTyped(json, false);
}
function SessionOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(Session_1.SessionFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function SessionOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(Session_1.SessionToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
